<template>
  <q-markup-table flat bordered wrap-cells dense separator="cell" :class="{ transparent }">
    <template v-for="(slot, name) in $slots" v-slot:[name]="scope">
      <slot :name="name" v-bind="scope ?? {}" />
    </template>
  </q-markup-table>
</template>

<script setup>
defineProps({
  transparent: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped lang="scss">
.q-markup-table {
  :deep(th) {
    font-size: 0.9rem;
  }
}

.transparent {
  background-color: transparent !important;
  border-color: white;

  :deep(th),
  :deep(td) {
    border-color: white;
    color: white;
  }
}

:not(.transparent) {
  :deep(thead tr:first-child th) {
    background-color: var(--q-primary);
  }

  :deep(th) {
    color: white;
  }
}
</style>
